import axios from "axios";

class LanguageModel {
  getLanguageTranslate(lang) {
    return axios.get(`https://kirovogradvesy.com/cities.php?type=getString&lang=${lang}`);
  }
}

export {LanguageModel};